import CookiesJS from 'cookies-js';

const CALL_DELAY = 1000;

export function initReplaceRecipe($, apiClient) {
    let calledAt;

    // Ожидание живёт внутри окна замены, и окон на странице столько же,
    // сколько карточек. Показываем только то, в котором нажали «Выбрать»,
    // иначе класс complete лёг бы сразу на все.
    let activeOverlay = null;

    function showPreloader(scope) {
        activeOverlay = scope && scope.length ? scope.find('.preloader-overlay') : $('.preloader-overlay');
        // Снимаем галочки прошлой попытки: после неудачной замены окно
        // остаётся открытым, и при повторном нажатии шаги загорелись бы
        // сразу, ничего ещё не сделав.
        activeOverlay.find('.preloader-text-container p').removeClass('complete');
        activeOverlay.show();
        // Все три фразы видны сразу, галочки добавляются по мере шагов.
    }

    function hidePreloader() {
        (activeOverlay || $('.preloader-overlay')).hide();
    }

    function markStepComplete(step) {
        // Добавляем класс complete к соответствующей строке
        const scope = activeOverlay || $(document);
        scope.find(`.preloader-text-container p[data-step="${step}"]`).addClass('complete');
    }

    // Делегирование: кнопки замен появляются после того, как окно
    // подгрузит варианты, поэтому напрямую к ним не привязаться.
    $(document).on('click', '.action__replace-recipe', async function (e) {
        e.preventDefault();
        if (calledAt && new Date() - calledAt < CALL_DELAY) {
            return;
        }
        calledAt = new Date();

        showPreloader($(this).closest('.modal-replace'));

        try {
            const recipeId = $(this).attr('data-recipeId');
            const originalRecipeId = $(this).attr('data-originalRecipeId');
            const programmId = $(this).attr('data-programmId');
            
            // Шаг 1: Получаем программу
            const [programm] = await apiClient.getProgrammsByIds([programmId], CookiesJS.get('auth_token'));
            if (!programm) {
                throw new Error('Программа не найдена');
            }
            markStepComplete(1);

            // Шаг 2: Обновляем программу с новым рецептом
            for (const recipe of programm.recipes) {
                if (recipe.recipeId === originalRecipeId) {
                    recipe.recipeId = recipeId;
                }
            }

            const result = await apiClient.updateProgramm(programmId, {
                recipes: programm.recipes
            }, CookiesJS.get('auth_token'));
            
            if (!result) {
                throw new Error('Update programm result is empty');
            }
            markStepComplete(2);

            // Шаг 3: Корректируем программу
            await apiClient.adjustProgramm(programmId, CookiesJS.get('auth_token'));
            markStepComplete(3);

            // Пауза перед перезагрузкой: без неё третья галочка загорается
            // и тут же исчезает вместе со страницей — человек видит, что
            // шаг остался невыполненным, хотя он выполнен. 150 мс хватает,
            // чтобы галочка проявилась: её собственный переход столько же.
            await new Promise(resolve => setTimeout(resolve, 150));
            location.reload();
        } catch (e) {
            // В случае ошибки скрываем прелоадер и показываем алерт
            hidePreloader();
            alert('Что-то пошло не так');
            console.error(e);
            if (e.response) {
                console.log(e.response);
            }
        }
    });
}